import Appsignal from "@appsignal/javascript";
import Beyuna from "./classes/beyuna";
import { Collapse, Dropdown, Offcanvas, Modal, ScrollSpy } from "bootstrap";
import * as Popper from "@popperjs/core";
import { initializeModals, displaySessionExpiredModal } from "./modules/utils";

new Beyuna();

let appsignalKey = document.documentElement.dataset.debug === "false" ? "51595114-e897-41d4-aa07-dedeadf1a28e" : "4a57af33-aecd-4c62-b74a-0d0942e55c26";

window.Appsignal = new Appsignal({
  key: appsignalKey,
  revision: "1.13", // NOTE: match this with github repo version
});

import "./components/carousel";
import "./components/cookies";
import "./components/expandable_image";
import "./components/header";
import "./components/scrollreveal";
import "./components/sticky";
import "./components/shopping_cart_totals";
import "./components/contrast_party";
import "./components/language_select";

import "./pages/agenda";
import "./pages/event_list";
import "./pages/user_dashboard";
import "./pages/dashboard";
import "./pages/shop_filter";
import "./pages/shopping_cart";
import "./pages/tree";
import "./pages/payment_livestream";
import "./pages/payment_page";
import "./pages/payment_signup";
import "./pages/product_detail";
import "./pages/overview_filter";
import "./pages/news_filter";
import "./pages/e_mail_notification";
import "./pages/supplement_filter";
import "./pages/income_filter";
import "./pages/payment_subscription";
import "./pages/offline_sales";
import "./pages/create_distributor_shop";
import "./pages/product_download";
import "./pages/funnel";
import "./pages/promotion";
import "./pages/promotion_shop";
import "./pages/social_media_overview_filter";
import "./pages/create_distributor";
import "./pages/forecast_tree";
import "./pages/ticket_scan";

initializeModals(document);

// TODO: Figure out the correct way of importing modules.
// import Swiper from "swiper";
// import { Scrollbar, Autoplay, Navigation } from "swiper/modules";

// NOTE: this does not work for development since we use js to load the js file
onload = () => {
  document.body.classList.remove("preload"); // we remove the no-transition class to enable transitions
};

window.gm_authFailure = function () {
  // Incase the google maps API key is invalid.
  window.dispatchEvent(new CustomEvent("google-maps-api-failure"));
};

// Monkey patch the fetch function to handle 401 errors. (Session expired)
const { fetch: originalFetch } = window;
window.fetch = async (...args) => {
  let [resource, config] = args;
  let response = await originalFetch(resource, config);

  if (response.status === 401) {
    displaySessionExpiredModal();
    return Promise.reject(response);
  }

  return response;
};
